import React, { useEffect, useState } from 'react';

import { hasRoles, CREATE_CLIENT_ROLES } from '../../../util/RoleUtil';

import { retrieveClients, viewClient } from '../../../services/ClientService';

import { Table } from '../../common/table/Table';

import './ClientsSearch.css';

export const ClientsSearch = ({ context, navigateToWith, showToaster, setSpinnerText }) => {
  const [searchResults, setSearchResults] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setSpinnerText('Retrieving Clients');
      const [data, error] = await retrieveClients(context.username);
      if (data) {
        if (data.responseStatus === 'Success') {
          setSearchResults(data.clients);
        } else {
          showToaster(data);
        }
      } else {
        showToaster({
          responseStatus: 'Error',
          responseMessage: error.message,
        });
      }
      setSpinnerText(null);
    };
    fetchData();
  }, [setSpinnerText, context, setSearchResults, showToaster]);

  if (!searchResults) return null;

  const handleRowClick = async (client) => {
    setSpinnerText('Retrieving Client');
    const [data, error] = await viewClient(context.username, client.externalReference);
    if (data) {
      if (data.responseStatus === 'Success') {
        showToaster({
          responseStatus: 'Success',
          responseMessage: 'Client Information Retrieved',
        });
        setSpinnerText(null);
        navigateToWith('clientsView', 'clientsCreateGeneral', data);
        return;
      } else {
        showToaster(data);
      }
    } else {
      showToaster({
        responseStatus: 'Error',
        responseMessage: error.message,
      });
    }
    setSpinnerText(null);
  };

  const handleCreateNewButtonClick = () => {
    navigateToWith('clientsCreate', undefined, undefined);
  };

  return (
    <div className="clients-search">
      <Table
        tableData={searchResults}
        hiddenColumns={['externalReference', 'created', 'isDeleted', 'lastModified', 'clientConsents']}
        onRowClick={handleRowClick}
        tableTitle={'Clients'}
        buttonText={hasRoles(context, CREATE_CLIENT_ROLES) ? 'Create New' : undefined}
        onButtonClick={handleCreateNewButtonClick}
        buttonOneWidth={'135px'}
        buttonDisabled={false}
        maxRowCount={10}
        excludedFilterColumns={['firstName', 'lastName', 'idNumber', 'passportNumber']}
        searchEnabled
        filterEnabled
        horizontalScroll
      />
    </div>
  );
};
